module.exports = __webpack_public_path__ + "static/logo-d60f06c305a817c85d13cd58ffe0a3c6.png";